// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 369) return "static/chunks/369-6370609927a33ff0.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"280":"c609c76ad21ecff8","453":"f090f084294c518e","783":"06df16296f612af2","956":"b626371858c405ff"}[chunkId] + ".js";
};